import { CustomerQueryKeys } from "../Customer/keys";

export const ShopifyStoreQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "shopify-stores",
  ],
};
